import { Component, Inject} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CERTIFICATE_STAGE_TYPES, CODE_TYPES, LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { IPerson } from 'app/models/People/person';
import { IPersonCertificate } from 'app/models/People/person-certificate';
import { PersonService } from 'app/services/person/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-edit-individual-certificate',
  templateUrl: './add-edit-individual-certificate.component.html',
  styleUrls: ['./add-edit-individual-certificate.component.scss']
})
export class AddEditIndividualCertificateComponent {  
  public codeType: string[] = Object.values(CODE_TYPES);
  public stageType: string[] = Object.values(CERTIFICATE_STAGE_TYPES);
  public certificateData:IPersonCertificate = {id: 0, person: null, stage: "", codeType: "", certificateNumber: "", controlNumber: "", issueDate: null, recertificationDate: null, expirationDate: null, dateOfLetter: null, application: null};
  public uiData = LEAD_BASED_PAINT;
  public certificateForm = new UntypedFormGroup({      
    stage: new UntypedFormControl({value: "", disabled: this.data.canEdit}, [Validators.required]),
    codeType: new UntypedFormControl({value: "", disabled: this.data.canEdit}, [Validators.required]),
    certificateNumber: new UntypedFormControl({value: "", disabled: this.data.canEdit}, [Validators.required]),
    controlNumber: new UntypedFormControl({value: "", disabled: this.data.canEdit}),
    issueDate: new UntypedFormControl({value: "", disabled: this.data.canEdit}, [Validators.required]),
    recertificationDate: new UntypedFormControl({value: "", disabled: this.data.canEdit}),    
    expirationDate: new UntypedFormControl({value: "", disabled: this.data.canEdit}, [Validators.required]),    
    dateOfLetter: new UntypedFormControl({value: "", disabled: this.data.canEdit}),    
  }); 

  constructor(private readonly dialogRef: MatDialogRef<AddEditIndividualCertificateComponent>,
    @Inject(MAT_DIALOG_DATA) public data:{certificate: IPersonCertificate, person:IPerson, canEdit:boolean},
    public personService:PersonService,
    private readonly toastr: ToastrService,) {
      this.fillFormData();
  }

  updateCertificateData(): void {    
    for (const controlName in this.certificateData) {
      if (this.certificateForm.controls.hasOwnProperty(controlName)) {
        const value = this.certificateForm.controls[controlName].value;
        this.certificateData[controlName] = value === '' ? null : value;        
      }
    } 
  }

  fillFormData(): void {
    if (this.data.certificate === null)
    {
      const dateData = new Date();    
      this.certificateData.issueDate = dateData.toISOString().substring(0, 10)
      this.certificateData.dateOfLetter = dateData.toISOString().substring(0, 10)
      dateData.setMonth(dateData.getMonth() + 54)
      this.certificateData.recertificationDate = dateData.toISOString().substring(0, 10)
      dateData.setMonth(dateData.getMonth() + 6)
      this.certificateData.expirationDate = dateData.toISOString().substring(0, 10)
      this.certificateData.stage = this.stageType[0];
      this.certificateData.person = this.data.person;
    }    
    else{
      this.certificateData = this.data.certificate;
      this.certificateData.issueDate = this.certificateData?.issueDate?.substring(0, 10);
      this.certificateData.dateOfLetter = this.certificateData?.dateOfLetter?.substring(0, 10);
      this.certificateData.recertificationDate = this.certificateData?.recertificationDate?.substring(0, 10);
      this.certificateData.expirationDate = this.certificateData?.expirationDate?.substring(0, 10);
    }    

    for (const controlName in this.certificateData) {
      if (this.certificateForm.controls.hasOwnProperty(controlName)) {
        this.certificateForm.controls[controlName].setValue(this.certificateData[controlName]);
      }
    } 
  }

  onCodeTypeChange(event: any): void {
    let dateData = new Date();    
    if(this.certificateForm.controls.codeType.value === null || this.certificateForm.controls.codeType.value === '' || this.certificateForm.controls.codeType.value === CODE_TYPES.rrpRenovator || this.certificateForm.controls.codeType.value === CODE_TYPES.dustSamplingTech){
      dateData.setMonth(dateData.getMonth() + 54)
      this.certificateForm.controls.recertificationDate.setValue(dateData.toISOString().substring(0, 10));
      dateData.setMonth(dateData.getMonth() + 6)      
      this.certificateForm.controls.expirationDate.setValue(dateData.toISOString().substring(0, 10));
    }
    else{
      dateData.setMonth(dateData.getMonth() + 30)
      this.certificateForm.controls.recertificationDate.setValue(dateData.toISOString().substring(0, 10));
      dateData.setMonth(dateData.getMonth() + 6)      
      this.certificateForm.controls.expirationDate.setValue(dateData.toISOString().substring(0, 10));      
    }
  }

  clearDate(controlName: string): void {
    this.certificateForm.get(controlName)?.setValue(null);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {    
    this.updateCertificateData();        
    this.personService.savePersonCertificate(this.certificateData).subscribe(result=>{
      this.toastr.success("Certificate Added Successfully");
      this.dialogRef.close(true);
    },error=>{
      this.toastr.error("There was an error adding the certificate: "+error.error);
    })    
  }
}
